import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { SettingsService } from 'src/app/settings.service';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

@Component({
  selector: 'app-sub-subcategories',
  templateUrl: './sub-subcategories.component.html',
  styleUrls: ['./sub-subcategories.component.scss']
})
export class SubSubcategoriesComponent implements OnInit {
  @Input() categoryId!:string;
  @Input() categoryName!:string;
  @Input()id!: string;

  subSubCategories: any[] = [];
  loading: boolean = false;
  searchString: string = '';
  modalDelete = false;
  subSubCategoryIdToDelete: any;
  showCreateSubSubCategoryModal = false;
  showEditSubSubCategoryModal= false;
  selectedSubSubCategoryId!: string;
  selectedCategoryId: any;
  timekitResources: any[] = [];
  categories: any[] = [];

  constructor(
    private apiService: ApiService,
    public themingService: ThemingService,
    public router: Router,
    private settingsService: SettingsService,
    private lambdaService: LambdaService,
  ) {
  }

  ngOnInit(): void {
    this.getSubSubCategories()
    this.getCategories();
  }

  async getSubSubCategories(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getSubSubCategories(this.themingService.shopId);
      const subSubCategoryRows = Array.isArray(response.subSubCategories) ? response.subSubCategories : [];
      this.subSubCategories = subSubCategoryRows;
    } catch (error) {
      console.error('Error fetching subSubCategories:', error);
    }
  }


  async getCategories(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getCategories(this.themingService.shopId);
      const categoryRows = Array.isArray(response[0]) ? response[0] : [];
      this.categories = categoryRows;
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  }

  searchSubSubCategories(){
  }

  async deleteSubSubCategory(response: number) {
    if (response && this.subSubCategoryIdToDelete !== null) {
      this.loading = true;
      try {
        const subSubCategory = this.subSubCategories.find(subSubCat => subSubCat.subSubCategoryId === this.subSubCategoryIdToDelete);
        if (subSubCategory && subSubCategory.subSubCategoryImageUrl) {
          await this.deleteImage(subSubCategory.subSubCategoryImageUrl);
        }
        await this.lambdaService.deleteSubSubCategory(this.themingService.shopId, this.subSubCategoryIdToDelete);
        this.getSubSubCategories();
        $('#deleteSubSubCategoryModal').modal('show');
      } catch (error) {
        console.error('Error deleting subSubCategory:', error);
      } finally {
        this.loading = false;
        this.modalDelete = false;
      }
    } else {
      this.modalDelete = false;
    }
  }

  async deleteImage(imageUrl: string) {
    try {
      await this.lambdaService.deleteFile(imageUrl);
    } catch (error) {
      console.log('Error deleting image:', error);
    }
  }

  setEditingSubSubCategory(subSubCategoryId: string){
    this.settingsService.setEditingSubSubCategory(subSubCategoryId)
  }

  getCreatingSubSubCategory(){
    this.settingsService.getCreatingSubSubCategory()
  }

  setCreatingSubSubCategory(){
    this.settingsService.setCreatingSubSubCategory();
  }


  openCreateSubSubCategoryModal() {
    this.showCreateSubSubCategoryModal = true;
  }

  closeCreateSubSubCategoryModal() {
    this.showCreateSubSubCategoryModal = false;
  }

  handleSubSubCategoryCreated() {
    this.showCreateSubSubCategoryModal = false;
    this.getSubSubCategories()
  }

  openEditSubCategoryModal(subSubCategoryId: string) {
    this.selectedSubSubCategoryId = subSubCategoryId;
    this.selectedCategoryId = this.categoryId;
    this.showEditSubSubCategoryModal = true;
  }

  handleSubSubCategoryUpdated() {
    this.showEditSubSubCategoryModal = false;
    this.getSubSubCategories();
  }

  closeEditSubSubCategoryModal() {
    this.showEditSubSubCategoryModal = false;
  }

  closeModal(){
    $('#deleteSubSubCategoryModal').modal('hide');
  }
}

